<template>
  <div class="page">
    <div class="bj-img-div">
      <van-nav-bar
        title="登录"
        left-arrow
        :border="false"
        @click-left="onClickLeft"
      />
      <div class="form-div">
        <div class="form-top-div">
          <div class="label-div">账号</div>
          <van-field v-model="telephone" placeholder="请输入您的手机号" maxlength="11"/>
          <div class="label-div password-div">密码</div>
          <van-field v-model="password" type="password" placeholder="请输入密码" maxlength="20"/>
           <div class="forget-password-div" @click="toResetPassword()">忘记密码？</div>
        </div>
        <div class="button-div">
          <van-button color="#CE0022" class="login-button button-shadow" @click="toAccountNumberManagement()">登录
          </van-button>
          <van-button color="#990019" plain class="login-button" @click="toRegister()">快速注册</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, getUserId, getUserInfo } from '../api/login'
import { passwordEncryption } from '../utils/jsencrypt'

export default {
  name: 'Login',
  data () {
    return {
      telephone: '', // 手机号
      password: '' // 密码
    }
  },
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },

    // 快速注册
    toRegister () {
      this.$router.push('/register')
    },

    // 登录
    toAccountNumberManagement () {
      const that = this
      if (that.telephone === '') {
        that.$toast.fail('请输入您的手机号')
        return
      }
      if (that.password === '') {
        that.$toast.fail('请输入密码')
        return
      }
      that.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const params = {
        client_id: 'a8117f61-0643-43ba-a172-bca68f497051',
        client_secret: 'a376a615-1ba6-453f-8e30-f68ae0b1b3f9',
        grant_type: 'password',
        username: passwordEncryption(that.telephone),
        password: passwordEncryption(that.password)
      }
      getToken(params).then(res => {
        that.onLogin(res.data)
      }).catch(() => {
        this.$toast.fail('用户名或密码错误')
      })
    },

    // 获取token成功
    onLogin (resp) {
      window.localStorage.smartHistory = ''
      if (resp.access_token) {
        this.$toast.success('登录成功')
        window.localStorage.tokenType = resp.token_type
        window.localStorage.token = resp.access_token
        this.getUserIdData(resp.access_token)
      } else {
        this.$toast.fail('登录失败')
      }
    },
    // 根据token获取用户id
    getUserIdData (val) {
      getUserId(val).then(res => {
        window.localStorage.userId = res.data.rows[0].userId
        this.getUserInfoData(res.data.rows[0].userId)
      }).catch(() => {
        this.$toast.fail('获取用户id失败')
      })
    },
    // 根据用户id获取用户信息
    getUserInfoData (id) {
      getUserInfo(id).then(res => {
        window.localStorage.userInfo = JSON.stringify(res.data.rows[0])
        this.$router.replace('/accountNumberManagement')
      }).catch(() => {
        this.$toast.fail('获取用户信息失败')
      })
    },

    // 跳转到重置密码页面
    toResetPassword() {
      this.$router.push('/reset')
    }
  }
}
</script>

<style scoped>
  .bj-img-div {
    background-image: url("../assets/bj.png");
    background-size: 100%;
    background-repeat: no-repeat;
    height: 100%;
  }

  .van-nav-bar {
    background-color: transparent;
  }

  .page {
    width: 100%;
    background: #F7F8FA;
    height: 100%;
  }

  .form-div {
    width: 92%;
    background: #FFFFFF;
    border-radius: 8px;
    margin-left: 4%;
    height: 70%;
    position: absolute;
    bottom: 30px;
  }

  .form-top-div {
    padding: 7% 5% 7% 5%;
  }

  .label-div {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #27282E;
    text-align: left;
  }

  /deep/ .van-field__control {
    font-size: 18px;
  }

  .van-cell {
    padding-left: 0;
    padding-right: 0;
    border-bottom: 1px solid rgba(16, 12, 13, 0.0784313725490196);
  }

  .password-div {
    margin-top: 15px;
  }

  .forget-password-div {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #CE0022;
    text-align: right;
    margin-top: 15px;
  }

  .login-button {
    width: 95%;
    height: 50px;
    border-radius: 8px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 12px;
  }

  .button-shadow {
    box-shadow: 0px 6px 12px rgba(206, 0, 34, 0.3);
  }

  .button-div {
    width: 95%;
    margin-left: 5%;
    margin-bottom: 10px;
  }
</style>
